<template>
    <p>
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />
        {{ userStore.user.address }}
        <br />
        {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        <br />
        {{ userStore.user.ssn }}
        <br />
        <br />
        {{ creditBureau.address_name }}
        <br />
        {{ creditBureau.street_address }}
        <br /> {{ creditBureau.city }}, {{ creditBureau.state_abbrev }} {{ creditBureau.zipcode }}
        <br />
        <br /> Date: {{ date }}
    </p>
    <div class="page">
        <p class="letter-content">
            The Metro 2 Format is the industry standard which was created to address the issues of accuracy and completeness of information of handling consumer data. Consumer Reporting Agencies, such as yours, must participate in the accuracy process and guidelines required by the Metro 2 Format and Industry Standards. The consumer reporting agencies must work together to develop, maintain and enhance an industry-standard reporting format.
        </p>
        <p class="letter-content">
            In my previous notice to you, I have stated there has been several accounts reported inaccuracy on my consumer report which were reporting inaccurately and they are not Metro 2 Compliant. These accounts which were not metro 2 compliant should have been deleted for not following the industry standard required to maintain maximum possible accuracy. However these accounts came back verified meaning these accounts SHOULD BE BOTH 100%% ACCURATE AND COMPLETE but ARE NOT ACCURATE AND COMPLETE. This has been an utter failure to follow your reasonable procedures required by 15 U.S. Code 1681i(5)(A)(i) and (ii).
        </p>
        <p>
            <strong class="letter-content">
                THE FOLLOWING INFORMATION IS NOT ACCURATE AND NOT METRO-2 COMPLIANT:
            </strong>
        </p>
        <p>
            <template v-for="(accounts, index) in selectedAccounts">
                <strong>NAME OF ACCOUNT:</strong> {{ reportStore.getAccountDetail(accounts).furnisher_name }}<br>
                <template v-if="reportStore.getAccountDetail(accounts).reference_number">
                    <strong>REFERENCE NUMBER: </strong>{{ reportStore.getAccountDetail(accounts).reference_number }}<br>
                </template>
                <template v-else>
                    <strong>ACCOUNT NUMBER: </strong>{{ reportStore.getAccountDetail(accounts).account_number }}<br>
                </template>
                <strong>PROVIDE PHYSICAL PROOF OF VERIFICATION:</strong> UNVERIFIED ACCOUNT <br><strong>Detail:</strong><br/>
                <table class="table table-success table-striped table-hover mb-0">
                    <thead class="thead-primary">
                        <tr>
                            <th></th>
                            <th>
                                TransUnion
                            </th>
                            <th>
                                Experian
                            </th>
                            <th>
                                Equifax
                            </th>
                        </tr>
                    </thead>
                    <tbody class="table-striped">
                        <tr>
                            <td>Account Number:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].account_number }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].account_number }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].account_number }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Account Status:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].account_status }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].account_status }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].account_status }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Account Type:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].account_type }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].account_type }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].account_type }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Account Detail:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].account_detail }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].account_detail }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].account_detail }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Bureau Code:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].bureau_code }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].bureau_code }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].bureau_code }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Monthly Payment:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].monthly_payment }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].monthly_payment }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].monthly_payment }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Payment Status:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].payment_status }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].payment_status }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].payment_status }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Past Due:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].past_due }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].past_due }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].past_due }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Date Opened:</td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[0].date_opened) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[1].date_opened) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[2].date_opened) }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Date Last Active:</td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[0].date_last_active) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[1].date_last_active) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[2].date_last_active) }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Date Last Payment:</td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[0].date_last_payment) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[1].date_last_payment) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[2].date_last_payment) }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>High Credit:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].high_credit }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].high_credit }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].high_credit }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Last Reported:</td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[0].last_reported) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[1].last_reported) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[2].last_reported) }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Month Term:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].number_of_months }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].number_of_months }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].number_of_months }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Comments:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].comments }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].comments }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].comments }}
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </template>
        </p>
        <p class="letter-content">
            Delete this account for failure to follow reasonable procedures pursuant to 15 U.S.Code 1681i(5)(A)(i) and (ii) and failure to follow procedures to maintain maximum possible accuracy and violation of 15 U.S.Code § 1681e(b). Failure to maintain Metro-2 Compliance.
        </p>
        <p class="letter-content">
            As proof of identity, I have enclosed a copy of my driver’s license and proof of address. Once your investigation is completed and you deleted this information please mail me a complete and updated copy of my credit report to {{ userStore.user.address }} {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}.
        </p>
        <p style="page-break-after: always;">
            Thank you for your time,
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            {{ userStore.user.ssn }}
        </p>
    </div>
    <h1 style="margin: 5rem 5rem;">Personal Information</h1>
    <div class="row">
        <p>
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore()
            };
        },
        computed: {
            selectedAccounts() {
                return _.filter(this.reportStore.reports[this.userStore.user.email].report.accounts, function(account) {
                    if (
                        account[0].checkbox && account[0].checkbox == "1"
                        ||
                        account[1].checkbox && account[1].checkbox == "1"
                        ||
                        account[2].checkbox && account[2].checkbox == "1"
                    ) {
                        return account;
                    }
                });
            }
        },
        mounted() {
        }
    };
</script>